export const TOP_MENU_BAR_HEIGHT = 56;
export const ADDITIONAL_TOP_BAR_HEIGHT_EXCHANGES_PAGE = 42;
export const TOP_MENU_BAR_HEIGHT_EXCHANGES_PAGE =
  TOP_MENU_BAR_HEIGHT + ADDITIONAL_TOP_BAR_HEIGHT_EXCHANGES_PAGE;

export const TOP_MENU_ITEM_ICON_SIZE = 20;
